export default __webpack_public_path__ + "static/media/cross-browser.1d9275dd.png";